class MFRDraggableFix {
    constructor( index, element ) {
        this.$element = $( element );

        this.init();
    }

    init() {
        this.$element.bind('touchstart', (e) => {
            window.mfrScroll.stop();
        } );
        this.$element.bind( "touchend", (e) => {
            window.mfrScroll.start();
        } );
    }
}